import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiZap, FiGlobe, FiCheck } from 'react-icons/fi';

const PricingSection = ({ showHeader = true }) => {
  const features = [
    "Full access to the global article feed",
    "Real-time delivery protocol",
    "Full historical archive access",
    "Highly responsive technical editorial support"
  ];

  return (
    <section className="py-32">
      {showHeader && (
        <div className="max-w-5xl mb-24 text-left mx-auto px-0">
          <h3 className="text-5xl md:text-7xl font-black text-white tracking-tighter uppercase leading-[0.9] mb-8">
            The <span className="text-transparent" style={{ WebkitTextStroke: '1px #CCFF00' }}>Bureau</span> <br />
            Access
          </h3>
        </div>
      )}
      
      <div className="max-w-5xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative bg-[#0A0A0A] border border-white/5 overflow-hidden group"
        >
          <div className="absolute top-0 left-0 w-full h-1 bg-[#CCFF00]"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="p-12 md:p-20 border-r border-white/5">
              <div className="w-16 h-16 bg-[#CCFF00] flex items-center justify-center text-black mb-10">
                <SafeIcon icon={FiZap} className="text-3xl" />
              </div>
              
              <p className="text-slate-500 text-xs font-bold uppercase tracking-widest leading-relaxed mb-12">
                Premium news syndication protocol. Simple, flat pricing per language market.
              </p>

              <div className="space-y-8 mb-12">
                <div className="flex flex-col">
                  <div className="flex items-start gap-1">
                    <span className="text-2xl font-bold text-[#CCFF00] mt-2">€</span>
                    <span className="text-8xl font-black text-white tracking-tighter italic leading-none">999</span>
                    <span className="text-slate-600 font-mono-data text-[10px] uppercase tracking-widest self-end mb-2 ml-2">/ Monthly</span>
                  </div>
                  <p className="text-[10px] font-black text-[#CCFF00] uppercase tracking-[0.3em] mt-4">Per Language Feed</p>
                </div>

                <div className="pt-8 border-t border-white/5">
                  <div className="flex items-center gap-4 text-white">
                    <div className="w-10 h-10 bg-white/5 flex items-center justify-center">
                      <SafeIcon icon={FiGlobe} className="text-lg" />
                    </div>
                    <div>
                      <span className="block text-[10px] font-mono-data text-slate-500 uppercase tracking-widest">Global Expansion</span>
                      <span className="text-xl font-black tracking-tighter italic uppercase">+€999 <span className="text-xs not-italic text-slate-400">/mo</span></span>
                    </div>
                  </div>
                  <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mt-2">Per additional language market</p>
                </div>
              </div>

              <button className="w-full py-6 bg-[#CCFF00] text-black text-[11px] font-black uppercase tracking-[0.4em] hover:bg-white transition-all shadow-[0_20px_40px_rgba(204,255,0,0.1)]">
                Secure Feed Access
              </button>
            </div>

            <div className="p-12 md:p-20 bg-black/40 flex flex-col justify-center">
              <h4 className="text-[10px] font-black text-slate-500 uppercase tracking-[0.4em] mb-10">B2B Integration Benefits</h4>
              <ul className="space-y-6">
                {features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-4">
                    <div className="mt-1">
                      <SafeIcon icon={FiCheck} className="text-[#CCFF00]" />
                    </div>
                    <span className="text-sm font-medium text-slate-300 leading-tight">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingSection;